//#region import
import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Card } from "@mui/material";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import {
  BtnAdd,
  BtnBack,
  BtnSave,
  BtnSearch,
} from "components/Button/ButtonAll";
import { FormProvider, useForm } from "react-hook-form";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import { GridColDef } from "@mui/x-data-grid-pro";
import moment from "moment";
import { GetMenuPermission } from "utilities/SystemFunction";
import { useNavigate, useLocation } from "react-router";
import { TextBoxItem } from "components/Input/TextBox";
import { SelectItem } from "components/Input/Select/SelectItem";
import {
  BtnEditOnTable,
  BtnUploadOnTable,
} from "components/Button/ButtonTable";
import DialogPreview from "components/DialogPreview/DialogPreview";
import UploadFile from "components/Input/UploadFile";
//#endregion

interface IDataRow {
  sID?: any;
  dStart?: any;
  dEnd?: any;
  nStatus?: number;
  sStatus?: string;
  sRemark?: string;
  lstAttachFile?: any[];
  isNew?: boolean;
}

export default function SaveWorkingStatusForm() {
  const navigate = useNavigate();
  const AxiosFn = FnAxios();
  const DialogFn = FnDialog();
  const location = useLocation();
  const searchParams = location.search;
  const sID = new URLSearchParams(searchParams).get("sID");

  const [loadingTable, setLoadingTable] = useState(false);

  const [arrName, setArrName] = useState([]);
  const [arrYear, setArrYear] = useState([]);
  const [arrStatus, setArrStatus] = useState([]);
  const [dStart, setStart] = useState(null);
  const [arrDel, setArrDel] = useState([]);

  //Upload File
  const [arrAttachFile, setArrAttachFile] = useState([]);
  const [arrAttachFileAdd, setArrAttachFileAdd] = useState([]);
  const [IsOpenUpload, setIsOpenUpload] = useState(false);
  const [nNoUpload, setNoUpload] = useState(null);
  const handleClearAttachFile = useRef(null);
  const handleClearAttachFileAdd = useRef(null);

  const [nPermission, setPermission] = useState<boolean>(true); // Permission

  const form = useForm({
    shouldFocusError: true,
    shouldUnregister: false,
    mode: "all",
  });

  //Table
  const [dataRow, setDataRow] = useState<PaginationInterface>({
    ...initRows,
    nPageSize: 9999,
  });
  let dataColumn: GridColDef[] = [
    {
      field: "dStart",
      headerName: `${I18n.SetText("TimeAttendance.sStartDateAdmin")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      minWidth: 120,
      renderCell: (item) =>
        moment(item.row.dStart).add(543, "years").format("DD/MM/YYYY"),
    },
    {
      field: "sEnd",
      headerName: `${I18n.SetText("TimeAttendance.sEndDateAdmin")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 120,
      renderCell: (item) =>
        moment(item.row.dEnd).add(543, "years").format("DD/MM/YYYY"),
    },
    {
      field: "sStatus",
      headerName: `${I18n.SetText("TimeAttendance.sStatusWork")}`,
      headerAlign: "center",
      align: "left",
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
      minWidth: 120,
    },
    {
      field: "sRemark",
      headerName: `${I18n.SetText("TimeAttendance.sRemark")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
      minWidth: 120,
      renderCell: (item) => (
        <TextBoxItem
          id={`sRemark_${item.row.sID}`}
          name={`sRemark_${item.row.sID}`}
          label=""
          maxLength={150}
          required={false}
          IsShowMessageError={false}
          type={"text"}
          disabled={!nPermission}
        />
      ),
    },
    {
      field: "lstAttachFile",
      headerName: `${I18n.SetText("TimeAttendance.sAttachFile")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 80,
      renderCell: (item) =>
        item.row.lstAttachFile && item.row.lstAttachFile.length > 0 ? (
          <BtnEditOnTable
            id="btnEdit"
            key={"btnEdit"}
            IsDisabled={!nPermission}
            onClick={() => {
              handleSetUploadFile(item.row.sID);
            }}
          />
        ) : (
          <BtnUploadOnTable
            id={"btnUpload"}
            onClick={() => {
              setIsOpenUpload(true);
              setNoUpload(item.row.sID);
            }}
            IsDisabled={!nPermission}
          />
        ),
    },
  ];
  const handleSetUploadFile = (sID) => {
    let objRow = dataRow.arrRows.find((f) => f.sID === sID);
    if (objRow.lstAttachFile.length > 0) {
      setArrAttachFile(objRow.lstAttachFile);
      setNoUpload(sID);
      setIsOpenUpload(true);
    }
  };
  const getTable = (p: PaginationInterface) => {
    setLoadingTable(true);
    let objParam = {
      ...p,
      sID: sID,
      nYear: form.getValues("nYear"),
    };
    AxiosFn.Post(
      `TimeAttendance/GetTableSaveStatusForm`,
      objParam,
      (result) => {
        //Set Form Data
        result.lstData.forEach((f, index) => {
          if (index === 0) {
            form.setValue(`nName`, f.nUserID);
          }
          form.setValue(`sRemark_${f.sID}`, f.sRemark);
        });
        setArrYear(result.lstYear);
        setArrDel([]);

        setLoadingTable(false);
        setDataRow({
          ...p,
          arrRows: [...result.lstData],
          nDataLength: result.ObjTable?.nDataLength,
          nPageIndex: result.ObjTable?.nPageIndex,
        });
      }
    );
  };
  const getFormInitial = () => {
    DialogFn.BlockUI();
    AxiosFn.Get(`TimeAttendance/GetFormInitial`, {}, (result) => {
      DialogFn.UnBlockUI();
      form.setValue("nYear", moment().year());
      setArrName(result.lstNameActive);
      setArrStatus(result.lstStatusSaveStatus);
      getTable(dataRow);
    });
  };

  const handleSubmit = () => {
    let lstData: IDataRow[] = dataRow.arrRows;
    lstData.forEach((f) => {
      f.dStart = new Date(f.dStart).valueOf();
      f.dEnd = new Date(f.dEnd).valueOf();
      f.sRemark = form.getValues(`sRemark_${f.sID}`);
    });

    let objParam = {
      nUserID: form.getValues("nName"),
      lstData: lstData,
      lstDel: arrDel,
      isEditMode: !!sID,
    };
    DialogFn.Submit(`${I18n.SetText("PublishDoc.sConfirmSave")}`, () => {
      DialogFn.BlockUI();
      AxiosFn.Post(`TimeAttendance/onSubmitSaveStatus`, objParam, (result) => {
        DialogFn.UnBlockUI();
        if (result.nStatusCode === 208) {
          DialogFn.Warning(
            "มีการบันทึกข้อมูลของพนักงานท่านนี้แล้ว กรุณาบันทึกสถานะการปฏิบัติงานภายในชื่อของพนักงาน"
          );
        } else {
          DialogFn.Success(`${I18n.SetText("PublishDoc.sSaveSuccess")}`);
          DialogFn.CloseSubmit();
          navigate("/SaveWorkingStatusList");
        }
      });
    });
  };

  const handleConfirmUpload = () => {
    let arrClone = dataRow;
    let objClone = arrClone.arrRows.find((f) => f.sID === nNoUpload);
    if (arrAttachFile.length > 0) {
      objClone.lstAttachFile = arrAttachFile;
    } else {
      objClone.lstAttachFile = [];
    }
    arrClone.arrRows = [...arrClone.arrRows];
    setDataRow({ ...arrClone });
    setIsOpenUpload(false);
    setArrAttachFile([]);
    handleClearAttachFile.current(null);
  };

  const handleDelete = (e) => {
    DialogFn.Submit(`${I18n.SetText("PublishDoc.sConfirmDel")}`, () => {
      let arrClone = dataRow;
      arrClone.arrRows = arrClone.arrRows.filter((f) => !e.includes(f.sID));
      arrClone.arrRows = [...arrClone.arrRows];
      setDataRow({ ...arrClone });
      DialogFn.Success("ลบสำเร็จ");
      setArrDel([...arrDel, ...e]);
    });
  };
  const checkDateDuplicate = () => {
    let isDup = false;
    let arrRow = dataRow.arrRows;

    let dAddStart = form.getValues("dStart");
    let dAddEnd = form.getValues("dEnd");
    arrRow.forEach((iR) => {
      //วันเริ่มอยู่ในช่วง
      if (
        dAddStart.isBetween(moment(iR.dStart), moment(iR.dEnd), "days", "[]")
      ) {
        isDup = true;
      }
      //วันเสิ้นสุดอยู่ในช่วง
      if (dAddEnd.isBetween(moment(iR.dStart), moment(iR.dEnd), "days", "[]")) {
        isDup = true;
      }

      //วันเริ่มในตารางอยู่ในช่วงวันที่เพิ่ม
      if (moment(iR.dStart).isBetween(dAddStart, dAddEnd, "days", "[]")) {
        isDup = true;
      }

      //วันสิ้นสุดในตารางอยู่ในช่วงวันที่เพิ่ม
      if (moment(iR.dEnd).isBetween(dAddStart, dAddEnd, "days", "[]")) {
        isDup = true;
      }
    });
    return isDup;
  };
  const handleAdd = () => {
    let isDup = checkDateDuplicate();
    if (isDup) {
      DialogFn.Warning("มีข้อมูลของช่วงวันนี้แล้ว");
      return false;
    }
    let arrClone = dataRow;
    let arrID =
      arrClone.arrRows.length > 0 ? arrClone.arrRows.map((m) => m.sID) : [];
    let sID = arrID.length > 0 ? Math.max(...arrID) + 1 : 1;

    let objAdd = {} as IDataRow;
    objAdd.sID = sID + "";
    objAdd.dStart = form.getValues("dStart");
    objAdd.dEnd = form.getValues("dEnd");
    objAdd.nStatus = form.getValues("nStatus");
    objAdd.sStatus = arrStatus.find(
      (f) => f.value === form.getValues("nStatus")
    )?.label;
    objAdd.lstAttachFile = arrAttachFileAdd;
    objAdd.isNew = true;

    arrClone.arrRows = [...arrClone.arrRows, objAdd];
    setDataRow({ ...arrClone });

    //Clear Form
    form.setValue("dStart", null);
    form.setValue("dEnd", null);
    form.setValue("nStatus", null);

    handleClearAttachFileAdd.current(null);
    setArrAttachFileAdd([]);
  };

  const handleSearch = () => {
    getTable(dataRow);
  };

  const handleChangeName = (objUser) => {
    if (objUser) {
      let nUserID = objUser.value;
      AxiosFn.Post(
        `TimeAttendance/OnCheckDuplicateUserStatus`,
        { nUserID: nUserID },
        (result) => {
          DialogFn.UnBlockUI();
          if (result.nStatusCode === 208) {
            form.setValue("nName", null);
            DialogFn.Warning(
              "มีการบันทึกข้อมูลของพนักงานท่านนี้แล้ว กรุณาบันทึกสถานะการปฏิบัติงานภายในชื่อของพนักงานที่หน้าหลัก"
            );
          }
        }
      );
    }
  };

  useEffect(() => {
    GetMenuPermission(AxiosFn, setPermission, DialogFn);

    getFormInitial();
  }, []);

  const isAddNewInTable = dataRow.arrRows.filter((f) => f.isNew).length > 0;
  return (
    <FormProvider {...form}>
      <Grid item container justifyContent={"flex-end"} spacing={2}>
        <Grid item xs={12}>
          <Card sx={{ padding: 2, bgcolor: "#eaf6fe" }}>
            <Grid item container xs={12} spacing={1}>
              <Grid item md={3} xs={12}>
                <SelectItem
                  id={"selName"}
                  name={"nName"}
                  label={`${I18n.SetText("TimeAttendance.sName")}`}
                  onChange={(e) => handleChangeName(e)}
                  options={arrName || []}
                  required
                  disabled={!nPermission || dataRow.arrRows.length > 0 || !!sID}
                />
              </Grid>
              <Grid item md={2} xs={12}>
                <DatePickerItem
                  id={`dStart`}
                  name={`dStart`}
                  required
                  fullWidth
                  label={`${I18n.SetText("TimeAttendance.sStartDateAdmin")}`}
                  onChange={(e) => {
                    setStart(e);
                    if (e) {
                      form.setValue("dEnd", null);
                    }
                  }}
                  disabled={!nPermission}
                />
              </Grid>
              <Grid item md={2} xs={12}>
                <DatePickerItem
                  id={`dEnd`}
                  name={`dEnd`}
                  required
                  minDate={dStart}
                  fullWidth
                  label={`${I18n.SetText("TimeAttendance.sEndDateAdmin")}`}
                  disabled={!nPermission}
                />
              </Grid>
              <Grid item md={5} xs={12}>
                <SelectItem
                  id={"selStatus"}
                  name={"nStatus"}
                  label={`${I18n.SetText("TimeAttendance.sStatus")}`}
                  options={arrStatus || []}
                  required
                  disabled={!nPermission}
                />
              </Grid>
              <Grid item xs={12}>
                <UploadFile
                  id={`arrAttachFileAdd`}
                  name={`arrAttachFileAdd`}
                  IsDrag={false}
                  required={false}
                  arrFile={arrAttachFileAdd}
                  setarrFile={setArrAttachFileAdd}
                  IsFolder={false}
                  IsMultiple={false}
                  Extension={[
                    "pdf",
                    "jpg",
                    "jpeg",
                    "png",
                    "pdf",
                    "doc",
                    "docx",
                    "rar",
                    "zip",
                  ]}
                  nLimitFile={30}
                  sLimitFile={"MB"}
                  onClearFile={handleClearAttachFileAdd}
                  modeDisplay={"list"}
                  sFolderTemp={""}
                  IsMultiDelete={false}
                  sPositionText={"right"}
                  disabled={!nPermission}
                />
              </Grid>
              <Grid item container xs={12} justifyContent={"flex-end"}>
                <BtnAdd
                  id="btnAdd"
                  onClick={form.handleSubmit(
                    () => handleAdd(),
                    (err) => console.log("err", err)
                  )}
                />
              </Grid>
            </Grid>
          </Card>
        </Grid>

        <Grid item container justifyContent={"flex-end"} spacing={1}>
          <Grid item md={2} xs={12}>
            <SelectItem
              id={"selYear"}
              name={"nYear"}
              label={`${I18n.SetText("TimeAttendance.sYear")}`}
              options={arrYear || []}
              disabled={!nPermission}
            />
          </Grid>
          <Grid item>
            <BtnSearch
              id={"btnSearch"}
              txt="ค้นหา"
              onClick={handleSearch}
              IsDisabled={isAddNewInTable}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            sTableID={`tbAttendance`}
            columns={dataColumn}
            rows={dataRow}
            onLoadData={getTable}
            isLoading={loadingTable}
            isHiddenToolHead
            isHiddenPagination
            isShowCheckBox={nPermission}
            onDelete={handleDelete}
          />
        </Grid>

        {/* Action */}
        <Grid item xs={12}>
          <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
            <Grid item xs={6} md={6}>
              <BtnBack
                id={"btnBack"}
                onClick={() => navigate("/SaveWorkingStatusList")}
              />
            </Grid>

            {nPermission && (dataRow.arrRows.length > 0 || sID) ? (
              <>
                <Grid container item xs={6} md={6} justifyContent="flex-end">
                  <BtnSave id={"btnSave"} onClick={handleSubmit} />
                </Grid>
              </>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>

        {/* Dialog Upload files */}
        <DialogPreview
          IsOpen={IsOpenUpload}
          Title={`${I18n.SetText("TimeAttendance.sAttachFile")}`}
          required={true}
          onClose={() => {
            handleConfirmUpload();
          }}
          sMaxWidth="sm"
          CloseSave={true}
        >
          <Box sx={{ marginLeft: 1 }}>
            <UploadFile
              id={`arrAttachFile_${nNoUpload}`}
              name={`arrAttachFile_${nNoUpload}`}
              IsDrag={false}
              required={false}
              arrFile={arrAttachFile}
              setarrFile={setArrAttachFile}
              IsFolder={false}
              IsMultiple={false}
              Extension={[
                "pdf",
                "jpg",
                "jpeg",
                "png",
                "pdf",
                "doc",
                "docx",
                "rar",
                "zip",
              ]}
              nLimitFile={30}
              sLimitFile={"MB"}
              onClearFile={handleClearAttachFile}
              modeDisplay={"list"}
              sFolderTemp={""}
              IsMultiDelete={false}
              sPositionText={"right"}
              disabled={!nPermission}
            />
          </Box>

          <Box sx={{ height: "40px" }}></Box>
        </DialogPreview>
      </Grid>
    </FormProvider>
  );
}
